import { createSlice } from "@reduxjs/toolkit";
import { Payment, Return, Shipping, Support } from "../../assets/images";

export const initialData = {
  featureList: [
    {
      label: "Satisfaction Guarantee",
      description: "Guaranteed money-back policy",
      image: Return,
    },
    {
      label: "Free Shipping",
      description: "Free shipping with minimum spend",
      image: Shipping,
    },
    {
      label: "Online Support",
      description: "24/7 online customer support",
      image: Support,
    },
    {
      label: "Adaptable Payments",
      description: "Flexible payment methods",
      image: Payment,
    },
  ],
  faqList: [
    {
      label: "What is DC Fashion?",
      description:
        "DC Fashion is a Malaysia-based fashion brand inspired by supercars and sports cars, offering stylish and high-performance apparel.",
    },
    {
      label: "Is DC Fashion for everyday wear?",
      description:
        "Yes! Our designs combine comfort and style, making them perfect for daily wear, casual outings, and motorsport-inspired streetwear.",
    },
    {
      label: "What materials does DC Fashion use?",
      description:
        "We use premium-quality fabrics, including high-grade cotton, breathable polyester, and durable leather, ensuring comfort and longevity.",
    },
    {
      label: "Are DC Fashion products limited edition?",
      description:
        "Some collections are limited edition, especially those inspired by specific supercar models or collaborations.",
    },
    {
      label: "Where can I buy DC Fashion products?",
      description:
        "You can purchase directly from our official website, online stores, or selected retailers.",
    },
    {
      label: "How do I take care of my DC Fashion apparel?",
      description:
        "Each product comes with care instructions, but generally, we recommend cold wash, air drying, and avoiding harsh detergents to maintain quality.",
    },
  ],
};

const dataSlice = createSlice({
  name: "home",
  initialState: initialData,
  reducers: {},
  extraReducers: (builder) => {},
});

export const {} = dataSlice.actions;

export default dataSlice.reducer;
